import { ExclamationCircleFilled } from "@ant-design/icons";
import { Typography } from "antd";
import { BASE_PADDING, themeColors } from "index";
import React, { FC, ReactNode } from "react";
import Modal, { ModalProps } from "../Modal";

export interface ConfirmModalProps extends ModalProps {
  body?: ReactNode;
  titleText?: string;
}
const ConfirmModal: FC<ConfirmModalProps> = ({
  body = "You have unsaved changes. Are you sure you want to discard them?",
  okText = "Confirm",
  title,
  titleText = "Attention!",
  width = 300,
  ...rest
}) => {
  const confirmTitle = (
    <Typography.Title
      level={5}
      style={{
        alignItems: "center",
        display: "flex",
        gap: `${BASE_PADDING}`,
        margin: 0,
      }}
    >
      <ExclamationCircleFilled
        style={{ color: themeColors.default.warning.main, fontSize: 22 }}
      />
      {titleText}
    </Typography.Title>
  );
  return (
    <Modal
      closable={false}
      okText={okText}
      title={title ?? confirmTitle}
      width={width}
      {...rest}
    >
      {body}
    </Modal>
  );
};

export default ConfirmModal;
